import React, { useLayoutEffect, useMemo, useState } from 'react';
import TagManager from 'react-gtm-module';
import { apiUtils } from '@annexus/utils';
import Api from '../api/Api';
import Auth from '../api/Auth';

const AuthContext = React.createContext();
const auth = new Auth({ SSO_URL: process.env.REACT_APP_SAML_SSO_URL });
const apiUrl = process.env.REACT_APP_API_URL;

// Initialize Api and bind token
const api = new Api(auth, apiUrl);

const AuthProvider = (props) => {
  const isAuthenticated = auth.isAuthenticated();
  const [user, setUser] = useState(null);
  const [appIsReady, setAppIsReady] = useState(false);

  useLayoutEffect(() => {
    if (!isAuthenticated) {
      auth.redirectToLogin();
      return;
    }

    if (process.env.REACT_APP_SAML_ENABLED === 'true') {
      const token = auth.getToken();
      const userData = auth.getDataLayer(token);
      setUser(userData);
      setAppIsReady(true);
      // Google tag manager
      // TODO: Enable/uncomment when SAML is enabled
      // const tagManagerArgs = {
      //   gtmId: process.env.REACT_APP_GTM_CONTAINER_ID,
      //   dataLayer: userData,
      // };

      // TagManager.initialize(tagManagerArgs);
    }

    // Google tag manager
    const tagManagerArgs = {
      gtmId: process.env.REACT_APP_GTM_CONTAINER_ID,
    };

    TagManager.initialize(tagManagerArgs);

    auth.tryTriggerRefresh();

    window.history.replaceState(
      null,
      null,
      apiUtils.removeParamFromURL('token', window.location.href),
    );
  }, [isAuthenticated]);

  // make a login request
  const login = () => {
    auth.tryTriggerRefresh();
  };
    // clear the token in localStorage and the user data
  const logout = () => {
    auth.logout();
  };

  if (!isAuthenticated) {
    return <div />;
  }
  const AuthValues = useMemo(() => ({
    isAuthenticated, user, login, logout, api, appIsReady,
  }), [isAuthenticated, user, login, logout, api, appIsReady]);

  return (
    <AuthContext.Provider value={AuthValues} {...props} />
  );
};

const useAuth = () => {
  const context = React.useContext(AuthContext);
  if (typeof context === 'undefined') {
    throw new Error('useAuth must be used within a AuthProvider');
  }
  return context;
};
export { AuthProvider, useAuth };
